export default "__VITE_ASSET___ZV7O7S8__"